// API configuration for different environments
const getApiBaseUrl = (): string => {
  // Check if we're in Docker environment
  // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  //   // Development environment - through nginx proxy on port 8090
  //   return 'http://localhost:8090';
  // } else {
  //   // Production environment - through nginx proxy
  // }
  return `${window.location.protocol}//${window.location.host}`;
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    register: `${API_BASE_URL}/api/auth/register`,
    refresh: `${API_BASE_URL}/api/auth/refresh`,
  },
  files: {
    list: `${API_BASE_URL}/api/files`,
    upload: `${API_BASE_URL}/api/files/upload`,
    delete: (id: string) => `${API_BASE_URL}/api/files/${id}`,
    content: (id: string) => `${API_BASE_URL}/api/files/${id}/content`,
    view: (url: string) => url.startsWith('http') ? url : `${API_BASE_URL}${url}`,
    analyze: (id: string) => `${API_BASE_URL}/api/files/${id}/analyze`,
    export: (format: string) => `${API_BASE_URL}/api/files/export?format=${format}`,
  },
  public: {
    upload: `${API_BASE_URL}/api/public/upload`,
    file: (id: string) => `${API_BASE_URL}/api/public/files/${id}`,
    tempXmlDownload: (id: string) => `${API_BASE_URL}/api/public/temp-xml/${id}/download`,
    tempXmlCleanup: (id: string) => `${API_BASE_URL}/api/public/temp-xml/${id}/cleanup`,
    contact: `${API_BASE_URL}/api/public/contact`,
    posts: `${API_BASE_URL}/api/public/posts`,
    post: (id: string) => `${API_BASE_URL}/api/public/posts/${id}`,
  },
  admin: {
    messages: `${API_BASE_URL}/api/admin/messages`,
    markMessageRead: (id: string) => `${API_BASE_URL}/api/admin/messages/${id}/read`,
  },
} as const;

export default API_ENDPOINTS; 